import { ReportInstance } from 'domain/entity/reportInstance';
import getGenericUseCase from 'use-case/genericUseCase';

const readReportInstancesUseCase = getGenericUseCase<ReportInstance[], null>((client) => client(null));

export default readReportInstancesUseCase;
